import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountingChartResponseModel } from 'src/app/Models/AccountingChartResponseModel';
import { DaysIntervalChartRequest } from 'src/app/Models/DaysIntervalChartRequest';
import { ProfitResponseModel } from 'src/app/Models/ProfitResponseModel';
import { ApiUrlService } from '../Infrastructure/apiurl.service';

@Injectable({
  providedIn: 'root'
})
export class AccountChartService {

  constructor(private http:HttpClient, private apiUrl:ApiUrlService) { }
  private accountingChartUrl = this.apiUrl.LoadFinanceApi+"/Chart"
  getAccountingChart(requestDays: DaysIntervalChartRequest):Observable<AccountingChartResponseModel>{
    return this.http.post<AccountingChartResponseModel>(this.accountingChartUrl+"/GetAccountingChart",requestDays)
  }
  getProfit(requestDays: DaysIntervalChartRequest):Observable<ProfitResponseModel>{
    return this.http.post<ProfitResponseModel>(this.accountingChartUrl+"/getProfit", requestDays)
  }
}
